class FAQBlock {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.faqItems = this.root.querySelectorAll('[data-faq-item]');

        return true;
    }

    init() {
        this.setItems();
    }

    setItems() {
        if (!this.faqItems) return;

        this.onItem = this.onItemClick.bind(this);
        this.faqItems.forEach(item => {
            item.addEventListener('click', this.onItem);
        });
    }

    onItemClick(event) {
        const { currentTarget } = event;
        const questionBtn = currentTarget.querySelector('[data-faq-question]');
        const isExpanded = questionBtn.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
            this.closeItem(currentTarget);
        } else {
            this.openItem(currentTarget);
        }
    }

    openItem(container) {
        const btn = container.querySelector('[data-faq-question]');
        const answerBox = container.querySelector('[data-faq-answer]');
        const iconEl = container.querySelector('[data-faq-icon]');

        btn.setAttribute('aria-expanded', 'true');
        iconEl.classList.add('rotate-180');

        answerBox.style.maxHeight = answerBox.scrollHeight + 'px';
    }

    closeItem(container) {
        const btn = container.querySelector('[data-faq-question]');
        const answerBox = container.querySelector('[data-faq-answer]');
        const iconEl = container.querySelector('[data-faq-icon]');

        btn.setAttribute('aria-expanded', 'false');
        iconEl.classList.remove('rotate-180');

        answerBox.style.maxHeight = '0';
    }
}

const initFAQBlock = () => {
    const sections = document.querySelectorAll('[data-faq]');
    if (!sections.length) return;

    sections.forEach(el => {
        if (el.dataset.faqBound === '1') return;
        el.dataset.faqBound = '1';
        new FAQBlock(el);
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFAQBlock);
} else {
    initFAQBlock();
}
